import "./footer.css";
import { useEffect,useContext } from "react";
import { useLocation } from "react-router-dom";
import React from "react";
import RefreshContext from "./Components/RefreshContext";

function Footer(){
  
    const { triggerRefresh } = useContext(RefreshContext);

 const handleRefresh = () => {
    triggerRefresh();
  };
return(
<>
<button className="btn btn-icon btn-primary refresh-icon" onClick={handleRefresh} data-tooltip-content="Refresh" data-tooltip-id="global-tooltip"  style={{position: 'fixed', bottom: '5%', right: '20px', width: '3.313rem',height: '3.313rem', borderRadius: '50%', zIndex: '1',transform:'translate(0%, 50%)`'}}><i className="ri-refresh-line" style={{ fontSize: '25px' }}></i></button>
<footer className="footer mt-auto py-3 bg-white text-center">
                <div className="container">
                    <span className="text-muted">
                        Powered  by <a href="https://meraqui.com" target="_blank">
                            <span className="fw-semibold text-primary text-decoration-underline">Meraqui Ventures Pvt. Ltd.</span>
                        </a> All
                        rights
                        reserved
                    </span>
                </div>
</footer>
</>
);
}

export default Footer;